/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Prescription_Period_YearsInputs */

const en_case_prescription_period_years = /** @type {(inputs: Case_Prescription_Period_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prescription period (years)`)
};

const pt_br2_case_prescription_period_years = /** @type {(inputs: Case_Prescription_Period_YearsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo de prescrição (anos)`)
};

/**
* | output |
* | --- |
* | "Prescription period (years)" |
*
* @param {Case_Prescription_Period_YearsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_prescription_period_years = /** @type {((inputs?: Case_Prescription_Period_YearsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Prescription_Period_YearsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_prescription_period_years(inputs)
	return pt_br2_case_prescription_period_years(inputs)
});